<template>
  <div class="Ftim-box">
    <div class="Ftim-bt">
      <span>至德-</span>个人中心
      <i></i>
    </div>

    <div class="Current-box">
      <div class="Currbj-left"></div>

      <all-left></all-left>

      <div class="Current-right">
        <div class="Current-topic">
          <div class="Current-name">基础资料</div>
        </div>
        <div class="Current-cent">

          <div class="Current-list">
            <div class="Current-zuo">
              <span>头像</span>
              <img :src="userinfo.user.avatar?userinfo.user.avatar:'images/grzx.png'">
            </div>
            <div class="">
              <el-upload
                action=""
                :before-upload="handleBeforeUpload"
                :on-success="successHandle">
                <span class="Current-bianji">编辑</span>
              </el-upload>
            </div>
          </div>

          <div class="Current-list">
            <div class="Current-zuo">
              <span>昵称</span>
              <span class="Current-title">{{userinfo.user.name}}</span>
            </div>
            <div class="">
              <span class="Current-bianji" @click="modifyname()">编辑</span>
            </div>
          </div>

          <div class="Current-list">
            <div class="Current-zuo">
              <span>手机号</span>
              <span class="Current-title">{{userinfo.user.mobile.substr(0,3)+"****"+userinfo.user.mobile.substr(7)}}</span>
            </div>
            <div class="">
              <span class="Current-bianji" @click="modifyphone()">编辑</span>
            </div>
          </div>

          <div class="Current-list">
            <div class="Current-zuo">
              <span>密码</span>
              <span class="Current-title">********</span>
            </div>
            <div class="">
              <span class="Current-bianji" @click="modifymima()">编辑</span>
            </div>
          </div>
        </div>
      </div>

      <div class="Currbj-right"></div>
    </div>

    <!-- 修改手机号 -->
    <div class="">
      <el-dialog title="修改手机号" :visible.sync="dialphone" width="30%">
        <el-input
          placeholder="请输入新手机号"
          v-model="mobile"
        ></el-input>

        <div class="perbasis-yanz">
          <el-input
             v-model="code"
            type="code"
            class="logIn"
            placeholder="验证码">
          </el-input>
          <el-button
            type="primary"
            @click="iphone"
            :disabled="disable"
            >{{ buttonName }}
          </el-button>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="phoneclose">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 修改密码 -->
    <div class="">
      <el-dialog title="修改密码" :visible.sync="dialpassword" width="30%">
        <el-input
          class="password-list"
          placeholder="请输入旧密码"
          v-model="old_password"
        ></el-input>

        <el-input
          class="password-list"
          placeholder="请输入新密码"
          v-model="new_password"
        ></el-input>

        <el-input
          class="password-list"
          placeholder="请再次输入新密码"
          v-model="reset_password"
        ></el-input>
        
        <span slot="footer" class="dialog-footer">
          <el-button @click="mimaclose">取 消</el-button>
          <el-button type="primary" @click="subpasword">确 定</el-button>
        </span>
      </el-dialog>
    </div>

  </div>
</template>
<script>
import AllLeft from '../../components/Personleft.vue';//个人中心公用左侧
export default {
  components:{
    AllLeft
  },
  data() {
    return {
      token: localStorage.pctoken,  //获取token
      userinfo: JSON.parse(localStorage.user),  //获取token
      buttonName: "获取验证码",   //获取验证码文案
      count: 120,                //倒计时
      disable: false,            //获取验证码是否可点
      dialphone: false,      //修改手机号
      dialpassword: false,      //修改密码
      mobile: '',
      code: '',
      old_password:'',  //旧密码
      new_password:'',  //新密码
      reset_password:'', //确认密码
    };
  },
  created(){
    
  },

  methods: {
    
    
    //上传头像
    handleBeforeUpload(file) {
      const formData = new FormData();
      formData.append('img', file);
      this.uploadObject(formData);
      return false;
    },
    uploadObject(formData) {
      this.$layer.loading();
      this.$http.post('upload',formData,{
        headers: {
            'Authorization': 'Bearer ' + this.token}
      }).then(this.successHandle).catch(this.handleError);
    },
    successHandle(response) {
      this.$http.post('change/userinfo',{
        avatar: response.data.data.path,
      },{
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }).then((res)=>{
        this.$layer.closeAll('loading');
        if(res.data.code == 200){
          this.$layer.msg('编辑成功');
          this.userinfo.user.avatar = response.data.data.path;
          localStorage.setItem('user', JSON.stringify(this.userinfo));
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    },

    //修改姓名
    modifyname(){
      this.$prompt('请输入昵称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        this.$layer.loading();
        this.$http.post('change/userinfo',{
          name: value,
        },{
          headers: {
            'Authorization': 'Bearer ' + this.token
          }
        }).then((res)=>{
          this.$layer.closeAll('loading');
          if(res.data.code == 200){
            this.$layer.msg('修改成功');
            this.userinfo.user.name = value;
            localStorage.setItem('user', JSON.stringify(this.userinfo));
          }else{
            this.$layer.msg(res.data.message);
          }
        })
      })
    },

    //修改手机号
    modifyphone(){
      this.dialphone = true;
    },

    //取消修改手机号
    phoneclose(){
      this.mobile = '';
      this.code = '';
      this.dialphone = false;
    },

    //获取验证码
    iphone() {
      var lay = this.$layer;
      if(!this.mobile){
        this.$layer.msg('请先输入手机号');
        return
      }
      
      try{
        this.$layer.loading();
        this.$http.post('send/code',{
          'mobile': this.mobile,
        }).then((res)=>{
        if(res.data.code == 200){
          this.$layer.closeAll('loading');
          this.$layer.msg('发送成功');
          var timeout= setInterval(() => {
            if (this.count < 1) {
              this.disable = false;
              this.buttonName = "获取验证码";
              this.count = 120;
              clearInterval(timeout);
            } else {
              this.disable = true;
              this.buttonName = this.count-- + "s 后重新获取";
            }
          }, 1000);
        }else{
          this.$layer.msg(res.data.message);
        }
        }).catch(function (error) {
          // handle error
          console.log(error);
          lay.msg('error');
        })
      }catch (e) {
        this.$layer.msg(e);
      }
    },

    //修改手机号确认
    submit(){
      this.$layer.loading();
      this.$http.post('change/userinfo',{
        mobile: this.mobile,
        code: this.code
      },{
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }).then((res)=>{
        this.$layer.closeAll('loading');
        if(res.data.code == 200){
          this.$layer.msg('修改成功');
          this.userinfo.user.mobile = this.mobile;
          this.dialphone = false;
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    },

    //修改密码
    modifymima(){
      this.dialpassword = true;
    },

    //取消修改密码
    mimaclose(){
      this.old_password = '';
      this.new_password = '';
      this.reset_password = '';
      this.dialpassword = false;
    },

    //修改密码确认
    subpasword(){
      
      if(!this.old_password){
        console.log(111)
        this.$layer.msg('请填写旧密码');
        return
      }

      if(!this.new_password){
        this.$layer.msg('请填写新密码');
        return
      }

      if(!this.reset_password){
        this.$layer.msg('请再次填写新密码');
        return
      }

      if(this.new_password == this.old_password){
        this.$layer.msg('新密码与旧密码不能一致');
        return
      }

      if(this.new_password != this.reset_password){
        this.$layer.msg('两次新密码填写不一致');
        return
      }

      this.$layer.loading();
      this.$http.post('change/password',{
        old_password: this.old_password,
        new_password: this.new_password,
        reset_password: this.reset_password
      },{
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }).then((res)=>{
        this.$layer.closeAll('loading');
        if(res.data.code == 200){
          this.$layer.msg('修改成功');
          this.dialpassword = false;
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    },

  },
};
</script>
<style scoped>
  .Ftim-box{
    background: url(../../../public/images/dysjbjt.png) top no-repeat;
    margin-bottom: 20px;
  }
  .Ftim-bt{
    width: 1200px;
    margin: 72px auto 0;
    font-weight: bold;
    font-size: 48px;
    color: #333;
    line-height: 48px;
  }
  .Ftim-bt span{
    color: #D71E1C;
  }
  .Ftim-bt i{
    display: block;
    width: 48px;
    height: 4px;
    background: #D71E1C;
    margin-top: 30px;
  }
  .Current-box{
    width: 1200px;
    margin: 80px auto 0;
    display: flex;
  }
  .Currbj-left{
    width: 30px;
    height: 790px;
    background: url(../../../public/images/grleft.png) bottom no-repeat;
  }
  .Currbj-right{
    width: 30px;
    height: 790px;
    background: url(../../../public/images/grright.png) bottom no-repeat;
  }
  .Current-right{
    flex: 1;
    background: #fff;
    border-left: 1px solid #d8d8d8;
    padding: 40px 0 0 40px;
    height: 700px;
    overflow: auto;
    border-radius: 0 20px 0 0;
  }
  .Current-cent{
    max-height: 640px;
    overflow: auto;
    margin-right: 40px;
  }
  
  .Current-cent::-webkit-scrollbar {
    width: 2px;
    height: 4px;
    margin-top: 10px;
  }

  .Current-cent::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: rgba(0,0,0,0.2);
  }

  .Current-cent::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 0;
    background: rgba(0,0,0,0.1);
  }
  .Current-topic{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #d8d8d8;
    margin-right: 40px;
  }
  .Current-name{
    font-weight: bold;
    font-size: 24px;
    color: #333333;
  }
  .Current-unread{
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
  }
  .Current-unread span{
    width: 64px;
    height: 28px;
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%);
    border-radius: 14px;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
    margin-left: 10px;
    line-height: 28px;
    cursor: pointer;
  }
  ::v-deep .Current-unread .el-input__inner{
    width: 220px;
    height: 28px;
    background: #F2F2F2;
    border-radius: 14px;
    border: none;
  }
  ::v-deep .Current-unread .el-input__icon{
    line-height: 28px;
    margin-right: 10px;
  }
  .Current-list{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-bottom: 1px solid #D8D8D8;
    margin-top: 14px;
    padding-bottom: 14px;
  }
  .Current-zuo{
    display: flex;
    align-items: center;
  }
  .Current-zuo span{
    font-size: 16px;
    color: #000000;
    display: block;
    width: 110px;
  }
  .Current-zuo img{
    width: 56px;
    height: 56px;
    border-radius: 50%;
  }
  
  .Current-title{
    font-size: 16px;
    color: #333333;
    margin-left: 10px;
  }
  
  .Current-bianji{
    font-weight: 400;
    font-size: 16px;
    color: #333;
    padding-left: 20px;
    line-height: 26px;
    cursor: pointer;
    margin-left: 20px;
  }
  
  .Ftim-more{
    width: 180px;
    height: 36px;
    background: #F2F2F2;
    border-radius: 18px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 36px;
    text-align: center;
    margin: 40px auto 0;
    cursor: pointer;
  }
  .examine-mark{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 3;
  }
  .operate-tck{
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 10;
  }
  .Current-sobox{
    padding: 40px 78px 30px;
    background: #FFFFFF;
    border-radius: 12px;
  }
  .Current-sotop{
    display: flex;
    align-items: center;
  }
  ::v-deep .Current-sotop .el-input__inner{
    width: 250px;
    height: 32px;
    background: #F2F2F2;
    border-radius: 16px;
    border: none;
  }
  .Current-sotop span{
    width: 64px;
    height: 32px;
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%);
    border-radius: 16px;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
  }
  .Current-socent{
    padding: 0 30px;
    height: 96px;
    border-radius: 8px;
    border: 1px solid #D8D8D8;
    margin-top: 20px;
    display: flex;
    align-items: center;
  }
  .Current-socent img{
    width: 56px;
    height: 56px;
    border-radius: 50%;
  }
  .Current-sotitle{
    font-size: 16px;
    color: #333333;
    margin-left: 15px;
  }
  .Current-sophone{
    font-size: 16px;
    color: #D8D8D8;
    margin-left: 20px;
    font-style: normal;
  }
  .Current-sobut{
    width: 200px;
    height: 36px;
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%), #D8D8D8;
    border-radius: 18px;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    margin: 26px auto 0;
    cursor: pointer;
  }
  .perbasis-yanz{
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .logIn{
    width: 70%;
  }
  ::v-deep .perbasis-yanz .el-button{
    margin-left: 20px;
  }
  .password-list{
    margin-bottom: 20px;
  }
  
</style>